var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.text.content)?_c('rich-text-renderer',{attrs:{"document":_vm.text.content}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }